// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__IBViO","col":"Table_col__1C_mM","fulfillmentStatus":"Table_fulfillmentStatus__2zdv-","emailCol":"Table_emailCol__3Zj2G"};